import {updateLanguageFieldMap} from '@/pages/PerfectStoreUtils';
import {pepirisDisplayInitial} from '@/store/slices/perfectStoreSlice';
import {MAX_PEPIRIS_GUIDELINES} from '@/utils/constants/perfectStoreConstants';

export const createEmptyPepIrisGuideline = () => ({
  id: crypto.randomUUID(),
  content: {}
});

export const readPepIrisDisplay = (formData) =>
  formData?.pepirisDisplay || pepirisDisplayInitial;

const guidelineRows = (rows) => (Array.isArray(rows) ? rows : []);

export const nextGuidelineRows = (rows, enabled) => {
  const existing = guidelineRows(rows);
  if (!enabled || existing.length > 0) return existing;
  return [createEmptyPepIrisGuideline(), createEmptyPepIrisGuideline()];
};

export const addGuidelineRow = (rows) => {
  const existing = guidelineRows(rows);
  if (existing.length >= MAX_PEPIRIS_GUIDELINES) return existing;
  return [...existing, createEmptyPepIrisGuideline()];
};

export const removeGuidelineRow = (rows, index) => {
  const existing = guidelineRows(rows);
  if (index < 2) return existing;
  return existing.filter((_, rowIndex) => rowIndex !== index);
};

export const withPepIrisDisplay = (prev, partial) => ({
  ...prev,
  pepirisDisplay: {
    ...readPepIrisDisplay(prev),
    ...partial
  }
});

export const updateBannerText = (prev, langCode, field, value, hasError) => {
  const current = readPepIrisDisplay(prev);
  return withPepIrisDisplay(prev, {
    bannerText: updateLanguageFieldMap(
      current.bannerText,
      langCode,
      field,
      value,
      hasError
    )
  });
};

export const updateGuidelineText = (
  prev,
  listKey,
  index,
  langCode,
  value,
  hasError
) => {
  const current = readPepIrisDisplay(prev);
  const rows = guidelineRows(current[listKey]);
  return withPepIrisDisplay(prev, {
    [listKey]: rows.map((row, rowIndex) =>
      rowIndex === index
        ? {
            ...row,
            content: updateLanguageFieldMap(
              row?.content,
              langCode,
              'text',
              value,
              hasError
            )
          }
        : row
    )
  });
};
